<!--
* @Name：议价审批物料信息明细详情
* @Author: 刘玉
* @Date: 2021-12-02 16:13:46
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-02 16:13:46
-->
<template>
  <van-dialog
    class="attachment-dialog"
    :value="detailsVisible"
    title="附件信息"
    show-cancel-button
    cancel-button-text="关闭"
    cancel-button-color="#1989fa"
    :show-confirm-button="false"
    @cancel="close"
  >
    <div class="details-container">
      <hi-attachment :attach-list="attachList"></hi-attachment>
    </div>
  </van-dialog>
</template>

<script>
export default {
  name: 'AttachmentInfo',
  data() {
    return {}
  },
  props: {
    attachList: {
      type: Array,
      default: () => []
    },
    detailsVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('close-details-dialog')
    }
  }
}
</script>
<style lang="scss" scoped>
.details-container {
  height: 500px;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 0 20px;
}
</style>
